import React, { useContext, useEffect, useState } from "react"
import DfbButton from "../ui-kit/dfb_button"
import DfbHeadline from "../ui-kit/dfb_headline"
import PageContext from "../page-context"
import { showSettings, updateConsent } from "../../utils/usercentrics"
import { getBrand } from "../../configuration/brands"

const CConsentBanner = ({ serviceName, children }) => {
  const pageContext = useContext(PageContext)
  const [consent, setConsent] = useState(false)

  const brandColor = getBrand(pageContext.brand).primaryColor

  const handleCookieAccept = () => {
    updateConsent(serviceName, true)
  }

  const handleSettings = () => {
    showSettings()
  }

  useEffect(() => {
    window.addEventListener("ucEvent", function (e) {
      if (e.detail && e.detail.event === "consent_status") {
        setConsent(Boolean(e.detail[serviceName]))
      }
    })
  }, [serviceName])

  // TODO: move to ui modules
  return (
    <>
      {consent ? (
        children
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: `linear-gradient(90deg, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0.6) 100%) ${brandColor}`,
            width: "100%",
            aspectRatio: "16 / 9",
            marginTop: "32px",
          }}
        >
          <div className="c-ConsentBanner" style={{ maxWidth: "600px" }}>
            <DfbHeadline
              headline={`Wir brauchen deine Einwilligung, um Inhalte von ${serviceName} anzeigen zu dürfen:`}
              headline_level="h4"
              add_class="c-Headline-strokeLine"
            />
            <div className="c-ConsentBanner-container">
              <DfbButton
                secondary
                onClick={handleSettings}
                text="Weitere Einstellungen"
              />
              <DfbButton onClick={handleCookieAccept} text="Akzeptieren" />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default CConsentBanner
